import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { listProdotti, setPiano } from "./clubApi";
import { Btn, Card, inputCls } from "./ui";

// Editor generico: se passi onSave gestisci tu il salvataggio (usato per le proposte), altrimenti conferma il piano del cliente.
export default function PlanEditor({ cliente, initial, onSave, saveLabel, withTitle, onDone, onCancel }) {
  const src = initial || cliente.piano;
  const [cat, setCat] = useState([]);
  const [titolo, setTitolo] = useState(src.titolo || "");
  const [items, setItems] = useState((src.prodotti || []).map((p) => ({ ...p })));
  const [note, setNote] = useState(src.note || "");
  const [durata, setDurata] = useState(src.durata_giorni || 30);
  const [durataManual, setDurataManual] = useState(src.confermato === true || !!initial?.id);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { listProdotti().then((r) => setCat(r.filter((p) => p.attivo))).catch(() => {}); }, []);
  useEffect(() => {
    if (!durataManual && items.length) setDurata(Math.max(...items.map((p) => Number(p.durata_giorni) || 0)) || 30);
  }, [items, durataManual]);

  const add = () => {
    const p = cat.find((x) => x.codice === pick);
    if (!p || items.some((i) => i.codice === p.codice)) return;
    setItems([...items, { codice: p.codice, nome: p.nome, dose: p.dose, durata_giorni: p.durata_giorni }]); setPick("");
  };
  const save = async () => {
    if (items.length === 0) return toast.error("Aggiungi almeno un prodotto");
    if (withTitle && !titolo.trim()) return toast.error("Dai un nome alla proposta (es. «Base», «Completa»)");
    const payload = { prodotti: items, note, durata_giorni: Number(durata) || 30, titolo: titolo.trim() };
    if (onSave) return onSave(payload);
    setBusy(true);
    try { await setPiano(cliente.id, { ...payload, confermato: true }); toast.success("Percorso confermato: ora è visibile al cliente"); onDone(); } catch { toast.error("Errore nel salvataggio"); }
    setBusy(false);
  };
  return (
    <Card className="mt-3 space-y-4" data-testid="plan-editor">
      {withTitle && <input className={`${inputCls} py-2 text-sm font-semibold`} value={titolo} onChange={(e) => setTitolo(e.target.value.slice(0, 60))} placeholder="Nome (es. «Partenza leggera»)" data-testid="plan-titolo" />}
      <div className="space-y-2">
        {items.map((p, i) => (
          <div key={p.codice || i} className="rounded-2xl bg-[#0E0E10] border border-[#232328] p-3" data-testid={`plan-item-${p.codice}`}>
            <div className="flex items-start justify-between gap-2">
              <p className="font-medium text-sm">{p.nome}</p>
              <button onClick={() => setItems(items.filter((_, j) => j !== i))} className="text-[#9A948A] hover:text-[#ff9a9e]" data-testid={`plan-remove-${p.codice}`}><X size={16} /></button>
            </div>
            <div className="mt-2 space-y-2">
              <textarea className={`${inputCls} py-2 text-xs min-h-[40px]`} rows={1} value={p.dose || ""} placeholder="Come si usa (es. 60 ml al mattino)" onChange={(e) => setItems(items.map((x, j) => (j === i ? { ...x, dose: e.target.value } : x)))} />
              <label className="flex items-center justify-between gap-2 text-xs text-[#9A948A]">Durata (giorni)<input className={`${inputCls} w-20 py-1.5 text-xs text-center`} type="number" value={p.durata_giorni} onChange={(e) => setItems(items.map((x, j) => (j === i ? { ...x, durata_giorni: e.target.value === "" ? "" : Number(e.target.value) } : x)))} /></label>
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <select className={`${inputCls} py-2 text-sm`} value={pick} onChange={(e) => setPick(e.target.value)} data-testid="plan-pick">
          <option value="">Aggiungi un prodotto…</option>
          {cat.filter((p) => !items.some((i) => i.codice === p.codice)).map((p) => <option key={p.codice} value={p.codice}>{p.nome}</option>)}
        </select>
        <Btn variant="dark" className="px-4" onClick={add} disabled={!pick} data-testid="plan-add"><Plus size={16} /></Btn>
      </div>
      <label className="block rounded-2xl bg-[#0E0E10] border border-[#232328] px-3 py-2">
        <span className="block text-xs text-[#9A948A] mb-1.5">Durata del percorso (giorni)</span>
        <input className={`${inputCls} w-28 py-1.5 text-sm text-center`} type="number" min="1" value={durata} onChange={(e) => { setDurataManual(true); setDurata(e.target.value); }} data-testid="plan-durata" />
      </label>
      <textarea className={`${inputCls} min-h-[80px] text-sm`} placeholder="Una riga tua per il cliente (es. «Parti dall'aloe al mattino»)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="plan-note" />
      <div className="flex gap-2">
        <Btn onClick={save} disabled={busy} data-testid="plan-confirm">{busy ? "Salvo…" : saveLabel || "Conferma e rendi visibile"}</Btn>
        <Btn variant="ghost" onClick={onCancel}>Annulla</Btn>
      </div>
    </Card>
  );
}
